import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../context/AuthContext';
import { API_URL } from '../../config';
import '../../components/Tables/Admin/AdminTable.css';
import SiteLayout from '../../layouts/SiteLayout';
import Header from '../../components/Header/Header';

interface Role {
    id: number;
    name: string;
}

interface Permission {
    id: number;
    key: string;
    description?: string;
    roles?: Role[];
}

const PermissionsScreen: React.FC = () => {
    const { token } = useAuth();
    const [permissions, setPermissions] = useState<Permission[]>([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');


    const fetchPermissions = useCallback(async () => {
        try {
            const response = await fetch(`${API_URL}/v1/admin/permissions`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            if (response.ok) {
                const data = await response.json();
                setPermissions(data);
            } else {
                console.error('Failed to fetch permissions');
            }
        } catch (error) {
            console.error('Error fetching permissions:', error);
        } finally {
            setLoading(false);
        }
    }, [token]);

    useEffect(() => {
        if (token) {
            fetchPermissions();
        }
    }, [token, fetchPermissions]);

    const filteredPermissions = permissions.filter(perm =>
        perm.key.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (perm.description && perm.description.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    return (
        <SiteLayout>
            <Header icon='lock' title='Registre des Permissions' />
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <div>
                    <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1e293b' }}>Registre des Permissions</h1>
                    <p style={{ color: '#64748b' }}>Liste des permissions système (lecture seule). Les permissions sont gérées via les migrations de code.</p>
                </div>
                <div>
                    <input
                        type="text"
                        placeholder="Rechercher une permission..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="form-input"
                        style={{ width: '300px' }}
                    />
                </div>
            </div>

            {loading ? (
                <div style={{ textAlign: 'center', padding: '40px' }}>Loading permissions...</div>
            ) : (
                <div className="admin-table-container">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>Clé Technique</th>
                                <th>Description</th>
                                <th>Utilisée par</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredPermissions.map(perm => (
                                <tr key={perm.id}>
                                    <td>
                                        <div style={{ fontWeight: '500', color: '#6366f1' }}>{perm.key}</div>
                                    </td>
                                    <td>{perm.description || <span style={{ color: '#94a3b8', fontStyle: 'italic' }}>Aucune description</span>}</td>
                                    <td>
                                        {perm.roles && perm.roles.length > 0 ? (
                                            <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                                                {perm.roles.map(role => (
                                                    <span
                                                        key={role.id}
                                                        style={{
                                                            display: 'inline-block',
                                                            padding: '3px 10px',
                                                            backgroundColor: '#dbeafe',
                                                            color: '#1e40af',
                                                            borderRadius: '12px',
                                                            fontSize: '0.8rem',
                                                            fontWeight: '500'
                                                        }}
                                                    >
                                                        {role.name}
                                                    </span>
                                                ))}
                                            </div>
                                        ) : (
                                            <span style={{ color: '#94a3b8', fontSize: '0.85rem', fontStyle: 'italic' }}>
                                                Aucun rôle
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </SiteLayout>
    );
};

export default PermissionsScreen;
